import { FormattedMessage, FormattedNumber } from 'react-intl';

interface Props {
  costCents: number | null;
  currency: string;
}

export default function BillingSummary({ costCents, currency }: Props) {
  return (
    <div className="mt-4 border-t border-slate-200 pt-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-slate-900">
            <FormattedMessage id="schedule.activate.checkoutItem" />
          </p>
          <p className="text-sm text-slate-600">
            <FormattedMessage id="schedule.activate.checkoutOneTime" />
          </p>
        </div>
        <p className="text-base font-semibold text-slate-900">
          <FormattedNumber
            value={(costCents ?? 0) / 100}
            style="currency"
            currency={currency}
          />
        </p>
      </div>
    </div>
  );
}
